import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store, Select } from '@ngxs/store';
import { Observable, combineLatest, of } from 'rxjs';
import { map, tap, filter, take, switchMap, catchError } from 'rxjs/operators';
import { GoToLogin } from '../router/router.actions';
import { Injectable, inject } from '@angular/core';
import { AuthService, AuthState,  RefreshToken,  UserState } from '@fluxos/state';
import { Navigate } from '@ngxs/router-plugin';
import { OrganizationsQuery } from '../organizations/organizations.query';


// Vanilla auth guard
// v1
// export const authenticatedGuard: CanActivateFn = (
//   route: ActivatedRouteSnapshot,
//   state: RouterStateSnapshot
// ): Observable<boolean | UrlTree> => {
//   const authService = inject(AuthService);
//   const router = inject(Router);

//   return authService.checkAuthState().pipe(
//     map(isAuthenticated => {
//       if (isAuthenticated) {
//         return true;
//       }
//       return router.createUrlTree(['/signin'], {
//         queryParams: { redirect: state.url },
//       });
//     })
//   );
// };

// v2

export const authenticatedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const store = inject(Store);

  return authService.checkAuthState().pipe(
    switchMap(isAuthenticated => {
      if (isAuthenticated) {
        // Check if token is expired
        const token = store.selectSnapshot(AuthState.getToken);
        if (token) {
          const tokenPayload = JSON.parse(atob(token.split('.')[1]));
          const expirationTime = tokenPayload.exp * 1000; // Convert to milliseconds
          if (Date.now() >= expirationTime) {
            // Token is expired, try to refresh
            return store.dispatch(new RefreshToken()).pipe(
              map(() => true),
              catchError(() => of(router.createUrlTree(['/signin'], { queryParams: { redirect: state.url } })))
            );
          }
        }
        return of(true);
      }
      return of(router.createUrlTree(['/signin'], { queryParams: { redirect: state.url } }));
    })
  );
};

export const unauthenticatedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.checkAuthState().pipe(
    take(1),
    map((isAuthenticated) => {
      // console.log('*** UNAUTHENTICATED GUARD *** isAuthenticated:', isAuthenticated);
      if (isAuthenticated) {
        // console.log('*** UNAUTHENTICATED GUARD *** Redirecting to broadcasts');
        return router.createUrlTree(['/broadcasts']);
      }
      // console.log('*** UNAUTHENTICATED GUARD *** Allowing access');
      return true;
    }),
    // Added: Catch any errors and allow access
    catchError((error) => {
      console.error('*** UNAUTHENTICATED GUARD *** Error:', error);
      return of(true);
    })
  );
};



function checkOrganizationAccess(
  route: any,
  organizationsQuery: OrganizationsQuery,
  router: Router
): Observable<boolean | UrlTree> {
  const orgId = route.paramMap.get('orgId');
  if (!orgId) {
    return of(router.createUrlTree(['/']));
  }

  return organizationsQuery.checkOrganizationAccess(orgId).pipe(
    map(hasAccess => {
      if (hasAccess) {
        return true;
      } else {
        return router.createUrlTree(['/no-access']);
      }
    }),
    catchError(() => of(router.createUrlTree(['/error'])))
  );
}